export default "__VITE_ASSET__0ac82cd9__"